import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

function useMlinkFirmwareRevisions() {
    return useQuery('mlinkRevisions', async () => new Client().mlinkFirmware_GetMlinkFirmwareRevisions())
}

export default useMlinkFirmwareRevisions;